webpackJsonp([22962853030008],{

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResourceBlock = function ResourceBlock(_ref) {
	    var data = _ref.data;
	    return _react2.default.createElement(
	        'div',
	        null,
	        data.flexSections && data.flexSections.length > 0 && data.flexSections[0].bannerImage && _react2.default.createElement(
	            'a',
	            { href: '/' + data.slug },
	            _react2.default.createElement(
	                'div',
	                { className: 'featured-image' },
	                _react2.default.createElement('img', { src: data.flexSections[0].bannerImage.file.url, alt: data.title })
	            )
	        ),
	        !data.flexSections[0].bannerImage && data.academyStoryPreviewImage && _react2.default.createElement(
	            'a',
	            { href: '/' + data.slug },
	            _react2.default.createElement(
	                'div',
	                { className: 'featured-image' },
	                _react2.default.createElement('img', { src: data.academyStoryPreviewImage.file.url, alt: data.title })
	            )
	        ),
	        _react2.default.createElement(
	            'a',
	            { href: '/' + data.slug },
	            _react2.default.createElement('h3', { style: { textTransform: 'initial', marginBottom: '8px' }, className: 'h3', dangerouslySetInnerHTML: { __html: data.title } })
	        ),
	        (data.gapYearResourcesExcerptText || data.introText.introText) && _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: data.gapYearResourcesExcerptText ? data.gapYearResourcesExcerptText : data.introText.introText } }),
	        _react2.default.createElement(
	            'a',
	            { style: { marginTop: '10px', display: 'inline-block', cursor: 'pointer' }, className: 'hoverlink', href: '/' + data.slug },
	            'Read More'
	        )
	    );
	};
	
	exports.default = ResourceBlock;
	module.exports = exports['default'];

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResourceQuizBlock = function ResourceQuizBlock(_ref) {
	    var data = _ref.data;
	    return _react2.default.createElement(
	        'div',
	        null,
	        data.featuredImage && data.featuredImage.file.url && _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/' + data.slug },
	            _react2.default.createElement(
	                'div',
	                { className: 'featured-image' },
	                _react2.default.createElement('img', { src: data.featuredImage.file.url, alt: '' })
	            )
	        ),
	        _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/' + data.slug },
	            _react2.default.createElement('h3', { style: { textTransform: 'initial', marginBottom: '8px' }, className: 'h3', dangerouslySetInnerHTML: { __html: data.pageTitle } })
	        ),
	        _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: data.quizIntro.quizIntro } }),
	        _react2.default.createElement(
	            _gatsbyLink2.default,
	            { style: { marginTop: '10px', display: 'inline-block', cursor: 'pointer' }, className: 'hoverlink', to: '/' + data.slug },
	            'Take the quiz!'
	        )
	    );
	};
	
	exports.default = ResourceQuizBlock;
	module.exports = exports['default'];

/***/ }),

/***/ 586:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(6);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Hero = __webpack_require__(9);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Apply = __webpack_require__(20);
	
	var _Apply2 = _interopRequireDefault(_Apply);
	
	var _ResourceBlock = __webpack_require__(341);
	
	var _ResourceBlock2 = _interopRequireDefault(_ResourceBlock);
	
	var _ResourceQuizBlock = __webpack_require__(342);
	
	var _ResourceQuizBlock2 = _interopRequireDefault(_ResourceQuizBlock);
	
	var _Row = __webpack_require__(3);
	
	var _Row2 = _interopRequireDefault(_Row);
	
	var _Column = __webpack_require__(4);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GapYearResources = function (_React$Component) {
	    _inherits(GapYearResources, _React$Component);
	
	    function GapYearResources() {
	        _classCallCheck(this, GapYearResources);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    GapYearResources.prototype.render = function render() {
	        var _props$data = this.props.data,
	            pages = _props$data.pages,
	            quizPages = _props$data.quizPages;
	        //const seoKeywords = page.seoData.keywords ? page.seoData.keywords.toString() : ``
	        // console.log('THE PAGE DATA ===>', page);
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'page-resources' },
	            _react2.default.createElement(_reactHelmet2.default, { title: 'Gap Year Resources | Global Citizen Year' }),
	            _react2.default.createElement(_Hero2.default, { title: 'Gap Year Resources' }),
	            _react2.default.createElement(
	                _Row2.default,
	                { className: 'capper' },
	                pages.edges.map(function (edge, index) {
	                    if (edge.node.displayOnResourcesPage) {
	                        return _react2.default.createElement(
	                            _Column2.default,
	                            { width: '4', tablet: '6', mobile: '12', className: 'author-post resource-padding', key: index },
	                            _react2.default.createElement(_ResourceBlock2.default, { data: edge.node })
	                        );
	                    }
	                }),
	                quizPages.edges.map(function (edge, index) {
	                    if (edge.node.showOnResourcesPage) {
	                        console.log(edge.node);
	                        return _react2.default.createElement(
	                            _Column2.default,
	                            { width: '4', tablet: '6', mobile: '12', className: 'author-post resource-padding', key: index },
	                            _react2.default.createElement(_ResourceQuizBlock2.default, { data: edge.node })
	                        );
	                    }
	                })
	            ),
	            _react2.default.createElement(_Apply2.default, {
	                title: 'Curious about Global Citizen Year? This is a great place to start.',
	                buttonText: 'Request Info',
	                buttonUrl: '/#signup'
	            })
	        );
	    };
	
	    return GapYearResources;
	}(_react2.default.Component);
	
	exports.default = GapYearResources;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-gap-year-resources-js-7daea98c24574c3b493b.js